import React from 'react'
import { Banner } from 'components/Banners/Banner'
import { Preview, Section, Col } from 'component-catalog/previews/PreviewKit'

export function BannersMock(): React.ReactElement {
  return (
    <Preview>
      <Section label="Warning banner">
        <Col>
          <Banner
            variant="warning"
            text="LTV is being processed. You might not see the latest data."
          />
          <Banner
            variant="warning"
            text="Your trial expires in 3 days. Upgrade to continue."
          />
        </Col>
      </Section>
      <Section label="Success banner">
        <Col>
          <Banner
            variant="success"
            text="Your changes have been saved successfully."
          />
          <Banner
            variant="success"
            text="Export complete — check your email for the download link."
          />
        </Col>
      </Section>
    </Preview>
  )
}
